import React from 'react';
import { ContactInformation } from '@@Components/ContactInformation';
import { GoogleMap } from '@@Components/GoogleMap';
import toNumber from 'lodash/toNumber';
import { MapAndInformationContainer, MapWrapper } from './styled';
export const MapAndInformation = ({ location }) => {
    return (React.createElement(MapAndInformationContainer, null,
        React.createElement(MapWrapper, null,
            React.createElement(GoogleMap, { width: "555px", height: "315px", center: { lat: toNumber(location === null || location === void 0 ? void 0 : location.latitude), lng: toNumber(location === null || location === void 0 ? void 0 : location.longitude) } })),
        React.createElement(ContactInformation, null)));
};
